export default {
  "fields" : {
    "sections": [
      {
        "section_title": "Breakfast Sandwiches",
        "items": [
          {
            "item_title": "Bacon, egg and cheese sandwich",
            "item_description": "Nueske’s bacon, sharp cheddar and scrambled egg on biscuit",
            "item_price_1": "5.5",
            "item_price_2": "",
            "item_price_3": "",
            "item_addons": [
              {
                "addon_title": "On bagel, croissant or toast",
                "addon_price": "6.5"
              }
            ]
          },
          {
            "item_title": "Item 2",
            "item_price_1": "20",
            "item_description": "Lorem Itemsum",
            "addons": []
          },
          {
            "item_title": "Item 3",
            "item_price_1": "20",
            "item_description": "Lorem Itemsum",
            "addons": []
          }
        ]
      },
      {
        "section_title": "Section 1530052158269",
        "items": [
          {
            "item_title": "Item 1",
            "item_price_1": "20",
            "item_description": "Lorem Itemsum",
            "addons": []
          },
          {
            "item_title": "Item 2",
            "item_price_1": "20",
            "item_description": "Lorem Itemsum",
            "addons": []
          },
          {
            "item_title": "Item 3",
            "item_price_1": "20",
            "item_description": "Lorem Itemsum",
            "addons": []
          }
        ]
      },
      {
        "section_title": "Section 1530052167819",
        "items": []
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/testAcfData.js